import PropTypes from 'prop-types';
import { graphql, useFragment } from 'react-relay';

// components
import { SbSharedRefineMenuColorSelect } from '../SbSharedRefineMenuColorSelect/SbSharedRefineMenuColorSelect.jsx';

const itemSearchFragment = graphql`
    fragment SbSharedRefineMenuFilterColor_itemSearch on ItemSearchQueryConnection {
        ...SbSharedRefineMenuColorSelect_itemSearch
    }
`;

export const SbSharedRefineMenuFilterColor = ({
    itemSearch: itemSearchRef,
    filterName,
    filter,
}) => {
    const itemSearch = useFragment(itemSearchFragment, itemSearchRef);
    return (
        <SbSharedRefineMenuColorSelect
            itemSearch={itemSearch}
            filterName={filterName}
            filter={filter}
        />
    );
};

SbSharedRefineMenuFilterColor.propTypes = {
    itemSearch: PropTypes.object.isRequired,
    filterName: PropTypes.string.isRequired,
    filter: PropTypes.object.isRequired,
};
